import { SET_DEPOSIT_USER_DATA, SET_DEPOSIT_BALANCE, REMOVE_DEPOSIT_BALANCE, DO_CONFIRM, CLEAR_USER_ID, FINISH_DEPOSIT } from "../actions/actionTypes";

export const SetDepositUserData = (payload) => {
    return {
        type: SET_DEPOSIT_USER_DATA,
        payload
    };
};

export const SetDepositBalance = (payload) => {
    return {
        type: SET_DEPOSIT_BALANCE,
        payload
    };
};

export const RemoveDepositBalance = (payload) => {
    return {
        type: REMOVE_DEPOSIT_BALANCE,
        payload
    };
};

export const DoConfirm = (payload) => {
    return {
        type: DO_CONFIRM,
        payload
    };
};

export const ClearUserId = (payload) => {
    return {
        type: CLEAR_USER_ID,
        payload
    };
};

export const FinishDeposit = (payload) => {
    return {
        type: FINISH_DEPOSIT,
        payload
    };
};